import PropTypes from "prop-types";
import React, { Component } from "react";
import './CustomAccordion.scss';

interface CustomAccordionProps {
  isOpen?: any;
}

class CustomAccordion extends Component<CustomAccordionProps> {
  static propTypes = {
    isOpen: PropTypes.any
  };
  constructor(props) {
    super(props);
    this.state = {
      isContentVisible: props.isOpen
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      this.setState({
        isContentVisible: this.props.isOpen
      });
    }
  }
  render() {
    const {
      title,
      icons,
      children,
      isOpen,
      onToggle
    } = this.props;
    const {
      isContentVisible
    } = this.state;
    return <div className="accordion-item">
                <div className="accordion-title accordion-box" onClick={onToggle}>
                <div className="accordion-header">
                    <div className="accordion-icons">
                        {icons.map((i, index) => <span key={index} className={`fa fa-${i}`} />)}
                    </div>
                        <span className="accordion-title-text">{title}</span>
                    </div>
                    <span className={`fa fa-chevron-${isOpen ? 'up' : 'down'}`} />
                </div>
                <div className={`accordion-content ${isContentVisible ? 'visible' : ''}`}>
                    <div className="accordion-content-inner">
                        {children}
                    </div>
                </div>
            </div>;
  }
}
export default CustomAccordion;